<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="550"
      hide-overlay
    >
      <v-card class="body-1">
        <v-toolbar flat color="primary">
          <v-toolbar-title class="text--contrast">Прогресс уровня БП</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              class="text--contrast"
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-md>
          <v-row class='d-flex' v-if="dialog">
            <div class="pl-3">
              <div>
                <span>Бонусы: <span class="value-text">{{ bonusAmount }}</span>
                </span>
              </div>

              <div v-if="bpLevelName">
                <span>Текущий уровень: <span class="value-text">{{ bpLevelName }}</span>
                </span>
              </div>

              <div v-if="showNextLevelName">
                <span>Следующий уровень: <span class="value-text">{{ nextBpLevelName }}</span>
                </span>
              </div>

              <div class="mt-3"></div>

              <div v-if="showNextLevelName && totalPurchaseCondition !== null">
                <span>До перехода: <span class="value-text">{{ totalPurchaseCondition }}</span>
                </span>
              </div>

              <div v-if="showNextLevelName && timePassedCondition !== null">
                <span>Автоматический переход: <span class="value-text">{{ timePassedCondition }}</span>
                </span>
              </div>
            </div>
          </v-row>
        </v-container>
        <v-card-actions class="d-flex align-end">
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Закрыть</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
  Cropper,
} from 'vue-advanced-cropper';

import moment from 'moment';
import { User } from '@/api/User';
import { getMoneyStr } from '@/lib/moneyHelpers';

export default {
  name: 'BpLevelProgressPopup',
  components: { Cropper },
  props: ['value'],
  data: () => ({

  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    bonusAmount() {
      return this.currentUser.bonusBalance;
    },
    bpLevel() {
      return this.currentUser.bpLevel;
    },
    nextBpLevel() {
      return this.currentUser.nextBpLevel;
    },
    bpLevelName() {
      return this.bpLevel.name;
    },
    showNextLevelName() {
      return this.nextBpLevelName || !this.nextBpLevel;
    },
    nextBpLevelName() {
      if (this.nextBpLevel) {
        return this.nextBpLevel && this.nextBpLevel.name;
      }

      return 'Отсутствует';
    },
    totalPurchaseCondition() {
      if (!this.nextBpLevel) {
        return null;
      }

      const { params: userBpParams } = this.bpLevel;
      const { conditions = [] } = this.nextBpLevel.params;

      const totalPurchaseCondition = conditions.find(({ code }) => code === 'totalPurchaseAmount');
      if (!totalPurchaseCondition) {
        return null;
      }

      const remindSum = totalPurchaseCondition.value - userBpParams.totalPurchaseAmount || 0;
      return getMoneyStr((remindSum > 0 ? remindSum : 0));
    },
    timePassedCondition() {
      if (!this.nextBpLevel) {
        return null;
      }

      const { conditions = [] } = this.nextBpLevel.params;
      const timePassedCondition = conditions
        .find(({ code }) => code === 'timePassedSinceActivation');

      if (!timePassedCondition) {
        return null;
      }

      const { activatedAt } = this.bpLevel;
      const { value } = timePassedCondition;

      const [count, nominal] = value.split(' ');

      return moment(activatedAt).add(+count, nominal).format('DD.MM.YYYY');
    },
    ...mapGetters(['currentUser', 'lang']),
  },
};
</script>

<style scoped lang="less">
.value-text {
  font-weight: 700;
}
</style>
